angular.module('picmonicng').directive('plsSubpathway', [
  function () {
    return {
      restrict: 'E',
      scope: {
        pathway: '=',
        subpathway: '=',
        furthersubpathways: '=',
        market: '=',
        scrollToType: '=',
        scrollToId: '=',
      },
      templateUrl: '/templates/directives/pls-subpathway.html',
      controller: [
        '$scope',
        'Pathways',
        'UserService',
        'PicmonicQueue',
        'BrowseService',
        function ($scope, Pathways, UserService, PicmonicQueue, BrowseService) {
          $scope.BrowseService = BrowseService;
          $scope.UserService = UserService;

          if ($scope.pathway.total_sub_pathways === 1) {
            BrowseService.visibleSubPathways.push($scope.subpathway.pathway_id);
          }

          $scope.getPicmonic = function (pathway) {
            return Picmonics.get({ pathway_id: pathway.pathway_id });
          };

          $scope.learn = function () {
            $scope.loadPlayAll = true;
            Pathways.query({ pathway_id: $scope.pathway.pathway_id, resource: 'picmonics' }, function (picmonics) {
              PicmonicQueue.setAndPlay(picmonics);
              send_ga('event', 'Pathway', 'Play All');
            });
          };
        },
      ],
    };
  },
]);
